<script setup lang="ts">
import { ref } from 'vue';

import type { IEditRoleProps } from './types';
import VPermissionsTree from '../VPermissionsTree/VPermissionsTree.vue';
import VRoleEditForm from '../VRoleEditForm/VRoleEditForm.vue';

defineProps<IEditRoleProps>();

const selectedRoleId = ref<number>();

function handleRoleUpdate(roleId?: number): void {
  selectedRoleId.value = roleId;
}
</script>

<template>
  <VRoleEditForm v-data-qa-auto-id="'VRoleEdit'"
    :namespace="namespace"
    :created-role-id="createdRoleId"
    @update-role="handleRoleUpdate"
  />
  <VPermissionsTree
    :namespace="namespace"
    :role-id="selectedRoleId"
  />
</template>
